import { Link } from "react-router-dom";
import { useArticlePath } from "@/lib/i18n";
import { Section, signed, deltaColor } from "./primitives";

export const WhyMoved = ({ events, coverage, threshold }: {
  events: any[]; coverage: any[]; threshold: number;
}) => {
  const toArticle = useArticlePath();
  return (
    <Section num="06" title="Why the Index Moved" sub="Recorded moves & their inputs" testid="li-why-section">
      <div className="grid lg:grid-cols-[minmax(0,7fr)_minmax(0,5fr)] gap-10 lg:gap-14">
        <div>
          <p className="nl-mono text-[9px] uppercase tracking-[0.25em] text-gray-500 mb-4">
            Index events · moves of ≥ {threshold} pts
          </p>
          {events.length ? (
            <div>
              {events.map((ev) => (
                <div key={ev.date} className="relative pl-6 pb-6 border-l border-white/[0.08] last:pb-0 last:border-transparent"
                  data-testid={`li-event-${ev.date}`}>
                  <span aria-hidden className="absolute -left-[6px] top-1 h-2.5 w-2.5 rounded-full border-2 border-[#05D1E5] bg-[#0b0c10]" />
                  <p className="nl-mono text-[10px] text-gray-500">{ev.date}</p>
                  <p className="mt-1 text-[14.5px] text-white font-semibold">
                    {ev.prev_value ?? "—"} → {ev.value}
                    <span className="nl-mono text-[11px] font-bold ml-2.5" style={{ color: deltaColor(ev.delta) }}>
                      {signed(ev.delta)} pts
                    </span>
                    {ev.state_change && (
                      <span className="nl-mono text-[9px] font-bold uppercase tracking-[0.14em] ml-2.5 px-1.5 py-0.5 rounded border border-white/15 text-gray-300">
                        {ev.prev_label} → {ev.label}
                      </span>
                    )}
                  </p>
                  {ev.driver && (
                    <p className="text-[12.5px] text-gray-400 mt-1">Strongest driver: {ev.driver}</p>
                  )}
                </div>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">
              No moves of ≥ {threshold} pts in recorded history yet.
            </p>
          )}
        </div>
        <div>
          <p className="nl-mono text-[9px] uppercase tracking-[0.25em] text-gray-500 mb-2">
            Headlines influencing today's sentiment score
          </p>
          <p className="text-[11px] text-gray-600 leading-relaxed mb-4">
            Scored directly by the sentiment component's bullish/bearish signal engine — these are actual
            index inputs, not editorial picks.
          </p>
          {coverage.length ? (
            <ul className="space-y-2.5" data-testid="li-coverage-list">
              {coverage.map((h: any, i: number) => (
                <li key={h.slug || i} className="flex gap-2.5 items-start">
                  <span aria-hidden className={`mt-[7px] h-1.5 w-1.5 rounded-full shrink-0 ${
                    h.direction === "bull" ? "bg-[#22C55E]" : h.direction === "bear" ? "bg-[#DC2626]" : "bg-gray-500"}`} />
                  <Link to={toArticle(h.slug)} data-testid={`li-coverage-${i}`}
                    className="font-news text-[13.5px] text-gray-300 hover:text-[#00E5FF] transition-colors leading-snug">
                    {h.title}
                  </Link>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-gray-500">No mood-driving headlines recorded yet today.</p>
          )}
        </div>
      </div>
    </Section>
  );
};
